export default __webpack_public_path__ + "static/media/unselectedLineChartIcon.406c2980.svg";